export function offerFileAsDownload(file: Blob, filename: string) {
  const url: string = window.URL.createObjectURL(file);
  const link: HTMLAnchorElement = document.createElement('a');
  link.href = url;
  link.download = `${filename}.csv`;
  link.click();
  window.URL.revokeObjectURL(url);
}
